import React from 'react';
import { Spin } from 'antd';
import type { SpinSize } from 'antd/lib/spin';
import './styles.scoped.css';

export interface LoadingProps {
  size?: SpinSize;
}

function Loading(props: LoadingProps) {
  const { size = 'default' } = props;
  return (
    <div className="loading-wrapper">
      <Spin className="loading" size={size} />
    </div>
  );
}

export default Loading;
